/**
 * Currency Configuration
 * Manage supported currencies and formatting
 */

export interface Currency {
  code: string
  symbol: string
  name: string
  decimalPlaces: number
  locale: string
}

export const CURRENCIES: Record<string, Currency> = {
  GHS: {
    code: 'GHS',
    symbol: '₵',
    name: 'Ghana Cedi',
    decimalPlaces: 2,
    locale: 'en-GH',
  },
  USD: {
    code: 'USD',
    symbol: '$',
    name: 'US Dollar',
    decimalPlaces: 2,
    locale: 'en-US',
  },
  EUR: {
    code: 'EUR',
    symbol: '€',
    name: 'Euro',
    decimalPlaces: 2,
    locale: 'en-EU',
  },
  GBP: {
    code: 'GBP',
    symbol: '£',
    name: 'British Pound',
    decimalPlaces: 2,
    locale: 'en-GB',
  },
  ZAR: {
    code: 'ZAR',
    symbol: 'R',
    name: 'South African Rand',
    decimalPlaces: 2,
    locale: 'en-ZA',
  },
  NGN: {
    code: 'NGN',
    symbol: '₦',
    name: 'Nigerian Naira',
    decimalPlaces: 2,
    locale: 'en-NG',
  },
  KES: {
    code: 'KES',
    symbol: 'KSh',
    name: 'Kenyan Shilling',
    decimalPlaces: 2,
    locale: 'en-KE',
  },
}

// Default currency for the church
export const DEFAULT_CURRENCY = CURRENCIES.GHS

/**
 * Format amount with currency
 */
export function formatCurrency(amount: number | undefined | null, currencyCode: string = 'GHS'): string {
  const currency = CURRENCIES[currencyCode] || DEFAULT_CURRENCY

  // Handle undefined, null, or NaN
  const safeAmount = amount ?? 0

  return `${currency.symbol} ${safeAmount.toLocaleString(currency.locale, {
    minimumFractionDigits: currency.decimalPlaces,
    maximumFractionDigits: currency.decimalPlaces,
  })}`
}

/**
 * Get currency symbol
 */
export function getCurrencySymbol(currencyCode: string = 'GHS'): string {
  const currency = CURRENCIES[currencyCode] || DEFAULT_CURRENCY
  return currency.symbol
}

/**
 * Get all supported currencies as array
 */
export function getSupportedCurrencies(): Currency[] {
  return Object.values(CURRENCIES)
}
